// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"style_play_btn__Kh4Fi","button-sequence":"style_button-sequence__gA4cI","first-shine":"style_first-shine__OcD56","desktop_play_btn":"style_desktop_play_btn__t54gI"};